import { useState, useRef } from "react";
import { ReactComponent as UserLogo } from "../../assets/icons/UserLogo.svg";
import AdminProfile from "./AdminProfile";

const DashboardTopHeader = () => {
  const [showProfile, setShowProfile] = useState(false);
  const profileButtonRef = useRef(null);

  return (
    <div className="dashboard-top-header">
      <div className="dashboard-top-header-left">
        <div>
          <h1 className="dashboard-top-header-title">Welcome back, Admin</h1>
          <p className="dashboard-top-header-subtitle">
            Here's what's happening with your AI interview platform today.
          </p>
        </div>
      </div>
      <div className="dashboard-top-header-right">
        <div className="dashboard-top-header-profile">
          <button
            ref={profileButtonRef}
            type="button"
            className="dashboard-top-header-profile-button"
            onClick={() => setShowProfile(!showProfile)}
            aria-label="Toggle profile"
          >
            <span className="dashboard-top-header-user-logo">
              <UserLogo />
            </span>
            <span className="dashboard-top-header-profile-text">Admin</span>
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {showProfile && (
            <AdminProfile onClose={() => setShowProfile(false)} buttonRef={profileButtonRef} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardTopHeader;

